"use client";

import { useSyncExternalStore } from "react";
import { formatCampaignCountdown } from "@/lib/campaigns/promotions/copy";

function subscribeToSeconds(onStoreChange: () => void): () => void {
	const timer = setInterval(onStoreChange, 1000);
	return () => clearInterval(timer);
}

/** Ganze Restsekunden: ändert sich höchstens einmal je Sekunde, also ein stabiler Snapshot. */

// Server und Hydration sehen keine Uhr: Sie rendern den festen Endtext.
const noClockOnServer = () => null;

interface CampaignCountdownProps {
	endsAt: string;
	/** Fester Endtext, z. B. „endet Sonntag, 23:59 Uhr“. */
	staticText: string;
	endsInLabel: string;
	day: string;
	days: string;
}

/**
 * Endet-Angabe der Top-Bar. Der Server rendert den festen Endtext; erst der Client
 * zählt im Sekundentakt. Feste Mindestbreite und Ziffern gleicher Breite halten die
 * Zeile ruhig, `aria-live="off"`, damit Screenreader nicht jede Sekunde vorlesen. Das
 * Ausblenden am Ende übernimmt die Hülle `CampaignAnnouncementExpiry`.
 */
export function CampaignCountdown({ endsAt, staticText, endsInLabel, day, days }: CampaignCountdownProps) {
	const seconds = useSyncExternalStore(
		subscribeToSeconds,
		() => Math.max(0, Math.ceil((Date.parse(endsAt) - Date.now()) / 1000)),
		noClockOnServer,
	);
	return (
		<span aria-live="off" className="inline-block min-w-[24ch] text-left tabular-nums">
			{seconds === null
				? staticText
				: `${endsInLabel} ${formatCampaignCountdown(seconds * 1000, { day, days })}`}
		</span>
	);
}
